import AccessDenied from "@/components/app/401";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_portal/401")({
  component: AccessDenied,
});
